export const COMPONENT_NAME = 'DownloadWidget';
